export type PostCheckinFormMarker = {
  pendingAt?: string;
  completedAt?: string;
  declinedAt?: string;
};

export type PostCheckinFormState = "completed" | "declined" | "pending";

/**
 * The state of the post-check-in questions, read the same way everywhere.
 *
 * Only `completedAt` means finished: a declined form carries answers and their presence proves
 * nothing. The CSV export writes the same three states.
 */
export const postCheckinFormState = (
  marker?: PostCheckinFormMarker | null,
): PostCheckinFormState => {
  if (marker?.completedAt) {
    return "completed";
  }

  return marker?.declinedAt ? "declined" : "pending";
};

export default postCheckinFormState;
